<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"events": "Events",
		"type": "Type",
		"date": "Date",
		"user": "User",
		"signature": "Signature",
		"location": "Location",
		"position":"Position",
		"received": "Received",
		"loaded": "Loaded",
		"collected": "Collected",
		"unloaded": "Unloaded",
		"delivered": "Delivered",
		"inbound": "Inbound",
		"outbound": "Outbound",
		"rejected": "Rejected",
		"unsuccessful": "Unsuccessful pickup",
		"requested": "Requested",
		"accepted": "Accepted",
		"appSend": "Sent to Confirm",
		"info": "Information",
		"ediInstructionReceived": "Inbound EDI",
		"ediInstructionSent": "Outbound EDI",
		"ediTrackAndTraceSent" : "Outbound EDI"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"events": "Hendelser",
		"type": "Type",
		"date": "Dato",
		"user": "Bruker",
		"signature": "Signatur",
		"location": "Lokasjon",
		"position":"Posisjon",
		"received": "Mottatt",
		"loaded": "Lastet",
		"collected": "Hentet",
		"unloaded": "Losset",
		"delivered": "Levert",
		"inbound": "Inngående",
		"outbound": "Utgående",
		"rejected": "Avslått",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Godtatt",
		"appSend": "Sendt til Confirm",
		"info": "Informasjon",
		"ediInstructionReceived": "Inngående EDI",
		"ediInstructionSent": "Utgående EDI",
		"ediTrackAndTraceSent" : "Utgående EDI"

	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header :icon="getIcon(data.type)" type="bp" :text="$t('events')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('type')"
						:value="$t(data.type)"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('date')"
						:value="getDate()"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('user')"
						labelMarginBottom="5px"
					>
						<template v-if="data.clerk.name">
							{{data.clerk.name}}
						</template>
						<template v-else-if="data.clerk.email">
							{{data.clerk.email}}
						</template>
						<template v-else-if="data.clerk.phoneNumber">
							{{data.clerk.phoneNumber}}
						</template>
					</TLabeledValue>
					<TLabeledValue
						:label="$t('location')"
						:value="locationInfo"
						labelMarginBottom="5px"
						style="grid-column: 1/3"
					/>
					<t-icon-button
						icon="map-marker"
						type="bp"
						appearance="minimal"
						disableBoxShadow
						:disabled="eventHasNoPosition()"
						@click="openPositionInGoogleMaps()"
					/>
					<TLabeledValue
						:label="$t('signature')"
						labelMarginBottom="5px"
					>
						<Signature
							:url="data.signatureUrl"
							:name="data.signatureName"
						/>
					</TLabeledValue>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
import { eventIcon, storageDateFormat } from '@/core';
import moment from 'moment';
import Signature from '@/modules/newOrder/common/Signature';

export default {
	name: 'Event',
	components: { Signature },
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	},
	computed: {
		locationInfo() {
			return (this.$i18n.locale==='nb-NO' || this.$i18n.locale==='nn-NO' || this.$i18n.locale==='no')
				? (this.data.info || this.data.infoEn)
				: (this.data.infoEn || this.data.info);
		},
		userInfo() {
			if (!this.data.clerk) return '';
			return this.data.clerk.name || this.data.clerk.email || this.data.clerk.phoneNumber;
		}
	},
	methods: {
		getIcon() {
			return eventIcon.getIcon(this.data.type);
		},
		getDate() {
			return moment(this.data.date.date, storageDateFormat).format('DD.MM.YYYY HH:mm');
		},
		openPositionInGoogleMaps() {
			let url = `https://www.google.com/maps/search/?api=1&query=${this.data.latitude},${this.data.longitude}`;
			let win = window.open(url, '_blank');
			win.focus();
		},
		eventHasNoPosition() {
			return !this.data.latitude || !this.data.longitude;
		}
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: repeat(3, minmax(150px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>